import axios from '@/plugins/axios';
import ErrorHandle from '@/helpers/errors/errorHandle';
import enumerateArray from '@/helpers/enumerateArray';

const initialState = {
  rentsListData: {},
  rentsStatuses: [],
  rentsTypes: [],
};
const getters = {
  getRentsListData: (state) => state.rentsListData,
  getRentsStatuses: (state) => state.rentsStatuses,
  getRentsTypes: (state) => state.rentsTypes,
};

const mutations = {
  setRentsListData(state, data) {
    state.rentsListData = data;
  },
  setRentsStatuses(state, data) {
    state.rentsStatuses = data;
  },
  setRentsTypes(state, data) {
    state.rentsTypes = data;
  },
};

/* eslint-disable no-unused-vars */
const actions = {
  async fetchRentsListData({ commit }, credentials) {
    try {
      commit('global/setLoader', true, { root: true });
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const searchString = credentials.searchString
        ? encodeURIComponent(credentials.searchString)
        : '';
      const page = credentials.page ? credentials.page : '';
      const rentStatus = credentials.rentStatus ? credentials.rentStatus : '';
      const rentDate = credentials.rentDate ? credentials.rentDate : '';
      const rentType = credentials.rentType ? credentials.rentType : '';
      const data = await axios.get(
        `/rents?page=${page}&searchString=${searchString}&status=${rentStatus}&date=${rentDate}&type=${rentType}`,
        { headers: { Authorization: `Bearer ${token}`, Lang: lang } },
      );

      const rentsListData = {
        ...data.data.data.rents,
        items: enumerateArray(
          data.data.data.rents.items,
          data.data.data.rents.currentPage,
          data.data.data.rents.lastPage,
        ),
      };

      commit('setRentsListData', rentsListData);
      commit('global/setLoader', false, { root: true });
      return rentsListData;
    } catch (error) {
      commit('global/setLoader', false, { root: true });
      throw ErrorHandle(error, this);
    }
  },
  async fetchRentsProperties({ commit }) {
    try {
      commit('global/setLoader', true, { root: true });
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const data = await axios.get('/rents/properties', {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      const { status, type } = data.data.data.properties;

      commit('setRentsStatuses', status);
      commit('setRentsTypes', type);
      commit('global/setLoader', false, { root: true });
      return data;
    } catch (error) {
      commit('global/setLoader', false, { root: true });
      throw ErrorHandle(error, this);
    }
  },
  /* eslint-disable no-unused-vars */
  async fetchRentDetails({ commit }, rentId) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const response = await axios.get(`/rents/${rentId}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return response.data.data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async downloadRentDocument({ commit }, rentId) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const response = await axios.get(`/rents/document?rentId=${rentId}`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return response.data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
  async checkRentTransmitting({ commit }, rentId) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const response = await axios.get(`/rents/${rentId}/isAccepting`, {
        headers: { Authorization: `Bearer ${token}`, Lang: lang },
      });

      return response.data.success;
    } catch (error) {
      if (error.response.status === 423) {
        return false;
      }
      throw ErrorHandle(error, this);
    }
  },
  async cancelRent({ commit }, cancelData) {
    try {
      const token = localStorage.getItem('token') || '';
      const lang = localStorage.getItem('language') || '';
      const response = await axios.post(
        `/rents/${cancelData.rentId}/complete`,
        { comment: cancelData.comment },
        { headers: { Authorization: `Bearer ${token}`, Lang: lang } },
      );

      return response.data;
    } catch (error) {
      throw ErrorHandle(error, this);
    }
  },
};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};
